import Inputmask from "inputmask";

(function () {
  const phone = document.getElementById("phone");

  if (phone) {
    // Phone Mask
    new Inputmask({
      mask: "(999)999-9999",
      showMaskOnHover: 0,
    }).mask(phone);
  }
})();
